import { render, staticRenderFns } from "./support-store.vue?vue&type=template&id=036305d4&scoped=true&lang=html&"
import script from "./support-store.vue?vue&type=script&lang=js&"
export * from "./support-store.vue?vue&type=script&lang=js&"
import style0 from "./support-store.vue?vue&type=style&index=0&id=036305d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036305d4",
  null
  
)

export default component.exports